export default __webpack_public_path__ + "static/media/pic1.fdbc0587.jpg";